var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[_c('div',{staticClass:"page-title flex-center-start"},[_c('img',{attrs:{"src":_vm.backUrl,"alt":""},on:{"click":_vm.back}}),_vm._v(" "+_vm._s(_vm.$t('mian-ze-sheng-ming'))+" ")]),_c('div',{staticClass:"disclaimer-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }